import { Injectable, signal, Type } from '@angular/core';
import { Subject } from 'rxjs';

// type MobileView = 'overview' | 'molstar';

export enum MobileView {
  Overview = 'overview',
  Molstar = 'molstar',
}

@Injectable({
  providedIn: 'root',
})
export class EntryService {
  private _entryData = signal<any>(null);
  public entryData = this._entryData.asReadonly();

  private _isEntryDataLoaded = signal(false);
  public isEntryDataLoaded = this._isEntryDataLoaded.asReadonly();

  private _domainData = signal<any>(null);
  public domainData = this._domainData.asReadonly();

  private _isDomainDataLoaded = signal(false);
  public isDomainDataLoaded = this._isDomainDataLoaded.asReadonly();

  public activeDomain = new Subject();

  private _mobileView = signal<MobileView>(MobileView.Overview);
  public mobileView = this._mobileView.asReadonly();

  private _selectedComponent = signal<Type<any> | null>(null);
  public selectedComponent = this._selectedComponent.asReadonly();

  private _selectedTabName = signal<string>('');
  public selectedTabName = this._selectedTabName.asReadonly();

  private _domainTitle = signal<string>('');
  public domainTitle = this._domainTitle.asReadonly();
  
  private _showError = signal<boolean>(false);
  public showError = this._showError.asReadonly();

  public setShowError(flag: boolean) {
      this._showError.set(flag);
  }


  public setEntryData(data: any) {
    if (data) {
      this._entryData.set(data);
      this._isEntryDataLoaded.set(true);
    }
  }
  public setDomainData(data: any) {
    if (data) {
      this._domainData.set(data);
      this._isDomainDataLoaded.set(true);
    }
  }

  public setActiveDomain(data: any) {
    if (data) {
      this.activeDomain.next(data);
    }
  }

  public setMobileView(view: MobileView) {
    this._mobileView.set(view);
    // this._selectedTabName.set(tabName);
  }

  public updateSelectedComponent(component: Type<any> | null) {
    this._selectedComponent.set(component);
  }

  public updateSelectedTabName(tabName: string) {
    this._selectedTabName.set(tabName);
  }

  public updateSelectedDomainTitle(title: string) {
    this._domainTitle.set(title);
  }
}
